export const DownloadIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M10 11.6667V1M10 11.6667L6.4 8.11111M10 11.6667L13.6 8.11111M1 13.4444L1.5589 15.6533C1.65624 16.0379 1.88094 16.3794 2.1973 16.6234C2.51365 16.8674 2.90351 16.9999 3.3049 17H16.6951C17.0965 16.9999 17.4863 16.8674 17.8027 16.6234C18.1191 16.3794 18.3438 16.0379 18.4411 15.6533L19 13.4444"
        stroke="#783AD0"
      />
    </svg>
  );
};

export const DownloadDisableIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M10 11.6667V1M10 11.6667L6.4 8.11111M10 11.6667L13.6 8.11111M1 13.4444L1.5589 15.6533C1.65624 16.0379 1.88094 16.3794 2.1973 16.6234C2.51365 16.8674 2.90351 16.9999 3.3049 17H16.6951C17.0965 16.9999 17.4863 16.8674 17.8027 16.6234C18.1191 16.3794 18.3438 16.0379 18.4411 15.6533L19 13.4444"
        stroke="#C7C6C6"
      />
    </svg>
  );
};
